module.exports = __webpack_public_path__ + "img/w3_package_white.bd2dc013.png";